import React from 'react';
import { currencyFormatter } from 'shared/utils/currencyFormatter';
import { Charges } from './TillReceipt';
import { displayAnnualAmount, useMonthlyDisplayPreference } from 'Quotes/utils/priceDisplay';

interface AnnualChargesTotalProps {
  priceAmortised: boolean;
  charges: Charges;
}

const AnnualChargesTotal: React.FC<AnnualChargesTotalProps> = ({ priceAmortised, charges }) => {
  const viewAsMonthly = useMonthlyDisplayPreference();
  const amount = priceAmortised ? charges.amortisedPrice : charges.annualPrice;
  return (
    <div className="price-summary__segment-wrapper">
      <div>{viewAsMonthly ? 'Monthly Charge' : 'Annual Charge'}</div>
      <div className="d-flex flex-column align-items-end flex-fill">
        <b className="total currency" data-testid="quote-page-annual-charge">
          {currencyFormatter.format(displayAnnualAmount(amount, viewAsMonthly) ?? 0)}
        </b>
      </div>
    </div>
  );
};

export default AnnualChargesTotal;
